export default {
  A: 'tagA',
  B: 'tagB',
  C: 'tagC',
  D: 'tagD',
  E: 'tagE',
}
